import { useState, useEffect, useCallback, useRef } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

const emptyForm = { name: "", phone: "", email: "", category: "" };

export function useProveedores() {
  const { authAxios } = useAuth();
  const authAxiosRef = useRef(authAxios);
  authAxiosRef.current = authAxios;
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNew, setShowNew] = useState(false);
  const [form, setForm] = useState(emptyForm);

  const fetchSuppliers = useCallback(async () => {
    try {
      const res = await authAxiosRef.current.get("/financiero/suppliers");
      setSuppliers(res.data);
    } catch {} finally {
      setLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => { fetchSuppliers(); }, [fetchSuppliers]);

  const createSupplier = async () => {
    if (!form.name) return;
    try {
      await authAxiosRef.current.post("/financiero/suppliers", form);
      toast.success("Proveedor creado");
      setShowNew(false);
      setForm(emptyForm);
      fetchSuppliers();
    } catch {
      toast.error("Error");
    }
  };

  return { suppliers, loading, showNew, setShowNew, form, setForm, createSupplier };
}
